/* eslint-disable react-hooks/exhaustive-deps */
import { Table, Modal, Input, Form, Button, Typography } from "antd";
import dayjs from "dayjs";
import { useEffect } from "react";

const { Text } = Typography;

const PurchasedCoursesModal = ({
  isModalOpen = false,
  purchasedCoursesList,
  userDetailsData,
  adminConfig = {},
  handleTransferSubscriptions = () => {},
  handleDownloadInvoice = () => {},
  setIsModalOpen = () => {}
}) => {
  const [form] = Form.useForm();
  const handleOk = () => {
    setIsModalOpen(false);
  };

  const handleCancel = () => {
    form.resetFields();
    setIsModalOpen(false);
  };

  // Set current email in form whenever the modal opens
  useEffect(() => {
    if (isModalOpen && userDetailsData.email) {
      form.setFieldsValue({ currentEmail: userDetailsData.email });
    }
  }, [isModalOpen, userDetailsData.email]);

  const columns = [
    {
      title: "S No.",
      dataIndex: "index",
      key: "index"
    },
    {
      title: "Course Name",
      dataIndex: "name",
      key: "name"
    },
    {
      title: "Batch Name",
      dataIndex: "batchName",
      key: "batchName"
    },
    {
      title: "Type",
      dataIndex: "type",
      key: "type"
    },
    {
      title: "Status",
      dataIndex: "status",
      key: "status"
    },
    {
      title: "Purchased On",
      dataIndex: "purchasedOn",
      key: "purchasedOn",
      render: (purchasedOn) => dayjs(purchasedOn).format("DD MMM YYYY | hh:mm")
    },
    {
      title: "Invoice",
      key: "invoice",
      render: (row) =>
        row?.isInvoiceDownloadSupportEnabled ? (
          <Button
            type="primary"
            size="small"
            onClick={() => handleDownloadInvoice(row.paymentId, () => {})}
          >
            Download
          </Button>
        ) : (
          "---"
        )
    }
  ];

  return (
    <Modal
      title="Subscriptions"
      open={isModalOpen}
      footer={[]}
      width={2000}
      onOk={handleOk}
      onCancel={handleCancel}
    >
      {adminConfig?.users?.hasUserSubscriptionTransferAccess && (
        <>
          <Text type="secondary">
            Transfer all user subscriptions from the current email to the new email.
          </Text>
          <br />
          <Form
            form={form}
            layout="inline"
            onFinish={(values) => {
              handleTransferSubscriptions(values);
            }}
          >
            <Form.Item label="Current Email">
              <Input value={userDetailsData.email} disabled />
            </Form.Item>
            <Form.Item
              name="newEmail"
              label="New Email"
              rules={[
                { required: true, message: "Please input new email!" },
                { type: "email", message: "Enter a valid email address!" }
              ]}
            >
              <Input placeholder="user@example.com" />
            </Form.Item>
            <Form.Item>
              <Button type="primary" htmlType="submit" block>
                Confirm Transfer
              </Button>
            </Form.Item>
          </Form>
        </>
      )}
      <br />
      <Table
        columns={columns}
        dataSource={purchasedCoursesList || []}
        bordered
        pagination={false}
        scroll={{ x: "max-content" }}
      />
    </Modal>
  );
};
export default PurchasedCoursesModal;
